import EDC from '../../../shared/globals';

EDC.Animations.Background = function (scene) {
  this.scene = scene;
};

EDC.Animations.Background.prototype.play = function () {
  this.scene.add.sprite(0, 0, 'background').setOrigin(0);
};

export default EDC.Animations.Background;
